import { render } from "./opportunity-page-details.vue?vue&type=template&id=6acbef3f&ts=true"
import script from "./opportunity-page-details.vue?vue&type=script&lang=ts"
export * from "./opportunity-page-details.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__